const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-arrow-round-back",
  "data-name": "Icon ionic-ios-arrow-round-back",
  d: "M22.064,11.752a1.777,1.777,0,0,1,.014,2.5l-8.254,8.281H45.275a1.768,1.768,0,0,1,0,3.535H13.824l8.267,8.281a1.79,1.79,0,0,1-.014,2.5,1.76,1.76,0,0,1-2.488-.014L8.385,25.553h0A1.985,1.985,0,0,1,8.018,25a1.687,1.687,0,0,1-.136-.68,1.772,1.772,0,0,1,.5-1.237l11.2-11.286A1.732,1.732,0,0,1,22.064,11.752Z",
  transform: "translate(-7.882 -11.252)",
  fill: "#fff"
});
function SvgIconionicIosArrowRoundBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.147,
    height: 26.109,
    viewBox: "0 0 39.147 26.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosArrowRoundBack);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-arrow-round-back.bbd87f5c.svg";
export { ForwardRef as ReactComponent };